<p>password-recover-form-component works!</p>
